var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__item form__input--numbers"},[_vm._t("default"),_c('i',{staticClass:"mdi mdi-menu-up icon icon-up",on:{"click":_vm.up}}),_c('i',{staticClass:"mdi mdi-menu-down icon icon-down",on:{"click":_vm.down}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }